<template>
  <transition name="dock-slide">
    <div v-if="teams.length" class="grid-transfer-dock">
      <div class="counter">
        <span class="counter-value">{{ teams.length }}</span>
        <span class="counter-label">{{ teamsWord }}</span>
      </div>

      <div class="chips" ref="chipsRef">
        <button v-for="team in teams"
                :key="`transfer-chip-${ team.id }`"
                class="chip"
                type="button"
                v-b-tooltip.hover.top="'Убрать из переноса'"
                @click="$emit('remove', team)">
          <span class="chip-name">{{ team.name }}</span>
          <span class="chip-remove">&times;</span>
        </button>
      </div>

      <div class="dock-actions">
        <button class="ghost-button" type="button" @click="$emit('clear')">
          Очистить
        </button>
        <button class="submit-button" type="button" @click="$emit('submit')">
          Перенести
          <span class="submit-arrow">&rarr;</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "GridTransferDock",
  props: {
    teams: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    teamsWord() {
      const count = this.teams.length
      const lastTwo = count % 100
      const last = count % 10
      if (lastTwo > 10 && lastTwo < 20) return 'команд'
      if (last === 1) return 'команда'
      if (last > 1 && last < 5) return 'команды'
      return 'команд'
    }
  },
  watch: {
    'teams.length'(newLength, oldLength) {
      if (newLength <= oldLength) return
      this.$nextTick(() => {
        const chips = this.$refs.chipsRef
        if (chips) chips.scrollLeft = chips.scrollWidth
      })
    }
  }
}
</script>

<style scoped lang="scss">
.grid-transfer-dock {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1030;

  display: flex;
  align-items: center;
  gap: 16px;

  max-width: min(900px, calc(100vw - 40px));
  padding: 12px 16px;
  border-radius: 16px;
  background: white;
  box-shadow: 0 10px 34px rgba(0, 0, 0, 0.22);
  border: 1px solid #ece9ff;

  @media screen and (max-width: 700px) {
    flex-wrap: wrap;
    gap: 10px;
    padding: 12px;
  }

  .counter {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    .counter-value {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 28px;
      height: 28px;
      padding: 0 6px;
      border-radius: 50px;
      background: #7366ff;
      color: white;
      font-size: 13px;
      font-weight: 700;
    }

    .counter-label {
      font-size: 12px;
      color: #7d7d8d;
    }
  }

  .chips {
    display: flex;
    align-items: center;
    gap: 6px;
    overflow-x: auto;
    padding: 2px;
    scrollbar-width: thin;

    @media screen and (max-width: 700px) {
      order: 3;
      width: 100%;
    }

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #d7d3ff;
      border-radius: 4px;
    }

    .chip {
      display: flex;
      align-items: center;
      gap: 6px;
      flex: 0 0 auto;
      max-width: 190px;

      padding: 5px 10px;
      border: 1px solid #ded9ff;
      border-radius: 50px;
      background: #f4f2ff;
      color: #4d43b5;
      font-size: 11px;
      font-weight: 600;
      transition: .2s;

      &:hover {
        background: #ffe9e9;
        border-color: #ffc9c9;
        color: #d13c3c;
      }

      .chip-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .chip-remove {
        font-size: 14px;
        line-height: 1;
      }
    }
  }

  .dock-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    white-space: nowrap;
  }

  .ghost-button {
    border: none;
    background: transparent;
    color: #7d7d8d;
    font-size: 12px;
    padding: 8px 10px;
    border-radius: 12px;
    transition: .2s;

    &:hover {
      background: #f1f0fb;
      color: #4d43b5;
    }
  }

  .submit-button {
    display: flex;
    align-items: center;
    gap: 8px;

    border: none;
    border-radius: 12px;
    padding: 9px 18px;
    background: #7366ff;
    color: white;
    font-size: 12px;
    font-weight: 600;
    box-shadow: 0 6px 16px rgba(115, 102, 255, 0.35);
    transition: .2s;

    &:hover {
      background: #5f51ff;
      transform: translateY(-1px);
    }

    .submit-arrow {
      font-size: 14px;
      line-height: 1;
    }
  }
}

.dock-slide-enter-active,
.dock-slide-leave-active {
  transition: opacity .2s ease, transform .2s ease;
}

.dock-slide-enter,
.dock-slide-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
